import { Box } from "@mui/material";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

interface LensTimelineTableProps {
  rows: Array<{
    id: string;
    user_email: string;
    date: string;
    dateFormatted: string;
    min_score: number;
    max_score: number;
    avg_score: number;
    stddev_score: number;
    median_score: number;
    q1_score: number;
    q3_score: number;
    scored_count: number;
    not_scored_count: number;
  }>;
  columns: GridColDef[];
}

const LensTimelineTable = ({ rows, columns }: LensTimelineTableProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <DataGridPro
        rows={rows}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
          sorting: {
            sortModel: [{ field: "date", sort: "desc" }]
          }
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        disableRowSelectionOnClick
        autoHeight
        density="compact"
        getRowClassName={(params) =>
          params.row.avg_score === 0 ? "zero-score-row" : ""
        }
        sx={{
          "& .zero-score-row": {
            color: "silver",
            "& .MuiDataGrid-cell": {
              color: "silver"
            }
          }
        }}
      />
    </Box>
  );
};

export default LensTimelineTable;
